// 开发环境
// const nginxURL = 'http://localhost/upload'
// const loginURL = 'http://localhost:8889/#/login'

// 生产环境
const nginxURL = 'http://pog.fudan.edu.cn/upload'
const loginURL = 'http://10.157.72.110:8889/#/login'

const UPLOAD_PATH = {
  articlecover: '/admin-upload/article/cover/',
  articlepdf: '/admin-upload/article/pdf/',
  meetingpdf: '/admin-upload/meeting/pdf/',
  pggresource: '/admin-upload/pggresource/',
  newscover: '/admin-upload/news/cover/',
  softwareimg: '/admin-upload/software/img/',
  softwarefile: '/admin-upload/software/file/',
  avatar: '/admin-upload/avatar/'
}

module.exports = {
  nginxURL,
  loginURL,
  UPLOAD_PATH,
  CODE_TOKEN_EXPIRED: -2
}
